var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-body" }, [
    _vm.seller
      ? _c(
          "fieldset",
          { staticClass: "border" },
          [
            _c("legend", { staticClass: "border" }, [_vm._v("ユーザ情報変更")]),
            _vm._v(" "),
            _vm.seller.countryCode === "jp" &&
            _vm.corporateIds.includes(parseInt(_vm.seller.corporateKbn))
              ? _c("japan-corporation-seller-info", {
                  attrs: { seller: _vm.seller }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.seller.countryCode === "jp" &&
            _vm.individualIds.includes(parseInt(_vm.seller.corporateKbn))
              ? _c("japan-individual-seller-info", {
                  attrs: { seller: _vm.seller }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.seller.countryCode === "cn" &&
            _vm.corporateIds.includes(parseInt(_vm.seller.corporateKbn))
              ? _c("china-corporation-seller-info", {
                  attrs: { seller: _vm.seller }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.seller.countryCode === "cn" &&
            _vm.individualIds.includes(parseInt(_vm.seller.corporateKbn))
              ? _c("china-individual-seller-info", {
                  attrs: { seller: _vm.seller }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-btn-renew text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info btn-renew w-120 mr-t-10",
                    attrs: { to: { path: "/update-register-info" } }
                  },
                  [_vm._v("更新")]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e1aeb39", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e1aeb39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/setting/UserInfo.vue
// module id = null
// module chunks = 